import { useStore } from '../store.js';

export function Toasts() {
  const toasts = useStore((s) => s.toasts);
  const dismiss = useStore((s) => s.dismissToast);

  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          className={`toast toast--${toast.tone}`}
          onClick={() => dismiss(toast.id)}
        >
          {toast.text}
        </button>
      ))}
    </div>
  );
}

export function ConnectionBanner() {
  const connection = useStore((s) => s.connection);
  if (connection === 'connected' || connection === 'idle') return null;

  const message =
    connection === 'connecting'
      ? 'Connecting…'
      : connection === 'reconnecting'
        ? 'Reconnecting — your seat is held for 90 seconds.'
        : 'Connection lost.';

  return <div className="connection-banner">{message}</div>;
}
